import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { CommonService } from 'src/app/share/services/common/common.service';

@Component({
    selector: 'app-add-supporting-document-type',
    templateUrl: './add-supporting-document-type.component.html',
    styleUrl: './add-supporting-document-type.component.scss',
    standalone: false
})
export class AddSupportingDocumentTypeComponent implements OnInit, OnChanges {
  supportingDocumentTypeFormGroup !: FormGroup;
  verifyLoader: boolean = false;
  errorMessage: string;
  @Input() isEdit: boolean = false;
  @Input() selectedSupportingDocumentType: any;
  @Output() closePanel: EventEmitter<any> = new EventEmitter();
  @Output() successToster: EventEmitter<any> = new EventEmitter();

  constructor(
    private readonly _fb: FormBuilder,
    private readonly lookupService: LookupService,
    public commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.createFormGroup();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedSupportingDocumentType'] || changes['isEdit']) {
      setTimeout(() => {
        if (this.isEdit && this.selectedSupportingDocumentType) {
          this.patchSupportingDocumentTypeForm(this.selectedSupportingDocumentType);
        } else {
          this.supportingDocumentTypeFormGroup?.reset();
        }
      });
    }
  }

  createFormGroup() {
    this.supportingDocumentTypeFormGroup = this._fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
  }

  patchSupportingDocumentTypeForm(item: any) {
    if (item) {
      this.supportingDocumentTypeFormGroup?.patchValue({
        name: item.name || '',
        description: item.description || ''
      });
    }
  }

  onCloseIconClick(value: any) {
    this.closePanel.emit(value);
    this.supportingDocumentTypeFormGroup?.reset();
    this.selectedSupportingDocumentType = null;
  }

  addSupportingDocumentTypeData() {
    this.lookupService.addSupportingDocumentType({ ...this.supportingDocumentTypeFormGroup.value })?.subscribe({
      next: (res) => {
        this.successMessageFunction('Supporting Document Type is added successfully');
      },
      error: (err) => {
        this.errorMessageFunction(err?.error?.message);
      }
    });
  }

  editSupportingDocumentTypeData() {
    this.lookupService.editSupportingDocumentType({ ...this.supportingDocumentTypeFormGroup.value }, this.selectedSupportingDocumentType._id)?.subscribe({
      next: (res) => {
        this.successMessageFunction('Supporting Document Type is updated successfully');
      },
      error: (err) => {
        this.errorMessageFunction(err?.error?.message);
      }
    });
  }

  errorMessageFunction(message: any) {
    this.errorMessage = message;
    this.verifyLoader = false;
  }

  successMessageFunction(message: any) {
    this.verifyLoader = false;
    this.onCloseIconClick(false);
    this.successToster.emit(message);
  }

  onSubmit() {
    this.verifyLoader = true;
    if (this.isEdit) {
      this.editSupportingDocumentTypeData();
    } else {
      this.addSupportingDocumentTypeData();
    }
  }

}
